import React from 'react';
import {
  Button,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from 'reactstrap';
import { getHostLabel, HostType } from 'views/sast2/helper';

const SelectAccountModal = ({
  hostType,
  connectedAccounts,
  onConnect,
  onClose,
}) => {
  //connectedAccounts:  [
  //   {id: 20, title: "github/naveed-ashraf-pk", host_type: "github"},
  //
  // ]

  const toggleModal = () => {
    onClose();
  };

  return (
    <Card>
      <Modal isOpen={true} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Connect Your {getHostLabel(hostType)} Account
        </ModalHeader>
        <ModalBody>
          {connectedAccounts.length > 0 && (
            <>
              <div>
                <p>
                  You already have the following {getHostLabel(hostType)}{' '}
                  accounts configured. Please select one of those account(s) to
                  connect your repositories for vulnerability scanning:
                </p>
                <ul className="list-unstyled">
                  {connectedAccounts.map((account) => (
                    <li key={account.id}>
                      {/* Call the handleConnect function on click */}
                      <Button
                        color="link"
                        onClick={() => onConnect(account.id)}
                      >
                        {account.title}
                      </Button>
                    </li>
                  ))}
                </ul>
              </div>
              <p>Alternatively, connect a new account:</p>
            </>
          )}
          {hostType === HostType.Azure && (
            <Alert color="secondary" className="mb-3">
              <p className="mb-1">
                <strong>Important:</strong> Connecting a new Azure DevOps
                account requires admin consent. If you’re not an admin, you’ll
                be prompted to request approval from your organization’s
                administrator. You can return here once the request is approved
                to complete the connection.
              </p>
              <p className="mb-0">
                <strong>For administrators:</strong> On the OAuth permissions
                screen, select
                <em> “Consent on behalf of your organization” </em> to grant
                access for other non admin users in your tenant to connect their
                accounts.
              </p>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onConnect(-1)}>
            Connect New Account
          </Button>{' '}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

export default SelectAccountModal;
